import { LivePreview } from '../LivePreview';
import { StructureDiagram } from '../StructureDiagram';
import { Block, Para, Bullets, Table } from '../print/PrintBlocks';
import { INDICADORES_DE_EXEMPLO } from '../exemplos';
import { StatsGrid } from '@/ui/StatsGrid';
import { Users, ClipboardList, AlertTriangle, Wallet } from 'lucide-react';
import { ItemDaDocumentacao } from '../ItemDaDocumentacao';

const ICONS = [Users, ClipboardList, AlertTriangle, Wallet];

export function VisaoGeralSection() {
  return (
    <div className="space-y-6">
      <ItemDaDocumentacao id="visao-geral-proposito">
        <Block>
          <Para>
            O Design System do Sistema TEG é a fonte única dos padrões visuais e de interação do
            produto. Ele existe para que Gestor, Fiscal, Financeiro e Transportador encontrem sempre
            a mesma linguagem, independentemente do módulo em que estejam.
          </Para>
          <Bullets
            items={[
              'Identidade visual da Prefeitura de São Paulo 2025 — Azul 654C primário, Vermelho 485C destrutivo, Laranja 021C de destaque.',
              'Todas as cores vivem como tokens semânticos em HSL; nenhuma cor pode ser escrita diretamente nos componentes.',
              'Tema claro e escuro são obrigatórios: se um componente quebra no escuro, ele está errado.',
              'Mobile first: a base é coluna única; breakpoints ampliam, nunca reduzem.',
              'Acessibilidade WCAG 2.1 AA é critério de aceite, auditado automaticamente no build.',
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="visao-geral-principios">
        <Block title="Princípios aplicados">
          <Table
            head={['Princípio', 'Como se manifesta no TEG']}
            rows={[
              [
                'Reuso antes de criação',
                'DataTable, FormPage, DetailHeader e PageHeader cobrem 90% das telas.',
              ],
              [
                'Tokens antes de valores',
                'bg-card, text-foreground, border-border — nunca cores fixas de branco ou cinza.',
              ],
              ['Estados completos', 'Toda tela entrega carregando, vazio, erro e sucesso.'],
              [
                'Complexidade no sistema',
                'O usuário não calcula: o sistema deriva status, prazos e valores.',
              ],
              [
                'Português claro',
                'Mensagens acionáveis em PT-BR; nunca mensagens técnicas ao usuário final.',
              ],
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="visao-geral-composicao">
        <Block title="Composição típica de uma tela">
          <StructureDiagram
            nodes={[
              {
                label: 'CascaDeArea',
                detail: 'barra lateral + cabeçalho + migalhas + área de conteúdo',
                children: [
                  { label: 'PageHeader', detail: 'título, descrição e ações' },
                  { label: 'PageBanner', detail: 'avisos contextuais logo abaixo do título' },
                  { label: 'StatsGrid', detail: 'cartões de indicadores do universo global' },
                  { label: 'FilterBar', detail: 'busca, filtros e limpar filtros' },
                  { label: 'DataTable', detail: 'listagem com seleção, ações e paginação' },
                ],
              },
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="visao-geral-indicadores">
        <Block title="Indicadores em componentes reais">
          <LivePreview surface="background" responsive>
            <StatsGrid
              // Uma coluna no celular: valor longo (R$ 4.812.930,00) não cabe em meia largura de 375 px.
              columns="grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
              stats={INDICADORES_DE_EXEMPLO.map((k, i) => ({
                title: k.label,
                value: k.value,
                icon: ICONS[i] ?? Users,
                description: k.hint,
              }))}
            />
          </LivePreview>
        </Block>
      </ItemDaDocumentacao>
    </div>
  );
}
